import { render, staticRenderFns } from "./AdmDataSource.vue?vue&type=template&id=0e472dad&scoped=true&"
import script from "./AdmDataSource.vue?vue&type=script&lang=js&"
export * from "./AdmDataSource.vue?vue&type=script&lang=js&"
import style0 from "./AdmDataSource.vue?vue&type=style&index=0&id=0e472dad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e472dad",
  null
  
)

export default component.exports